(() => {
  'use strict';
  // Shopify supplies the currently rendered theme, including in cookie-based previews.
  // A MAIN theme must never inherit preview parameters from an old URL or session.
  const theme = window.Shopify && window.Shopify.theme;
  const preview = theme && ['unpublished', 'development', 'demo'].includes(theme.role) && /^\d+$/.test(String(theme.id)) ? String(theme.id) : '';
  const config = document.querySelector('[data-finder-routing-config]');
  const draftKey = config && config.dataset.draftKey || '';
  const route = (value) => {
    const target = new URL(value, location.origin);
    if (target.origin !== location.origin) return target.href;
    target.searchParams.delete('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    else target.searchParams.delete('preview_key');
    return target.pathname + target.search + target.hash;
  };
  const finder = (value) => {
    const previous = new URL(value || location.href, location.origin);
    const target = new URL('/pages/find-your-rod', location.origin);
    if (preview && draftKey) {
      target.pathname = '/pages';
      target.searchParams.set('preview_key', draftKey);
    }
    const rods = previous.searchParams.get('rods');
    if (rods && /^\d+(,\d+){0,2}$/.test(rods)) target.searchParams.set('rods', rods);
    target.hash = previous.hash === '#compare-selected-rods' ? previous.hash : '#find-your-rod';
    return route(target);
  };
  window.JoottiFinderRouting = Object.freeze({ route, finder, preview });
  document.querySelectorAll('a[data-finder-link]').forEach((link) => {
    link.href = link.dataset.finderLink === 'finder' ? finder(link.href) : route(link.href);
  });
})();
